import { ReactComponent as IconInformation } from '@/assets/svgs/info-circle.svg';
import Button from '@/components/Button';
import DexLeftComponent from '@/components/DexLeftComponent';
import { useNavigate, useQuery } from '@/lib/router-dom';
import { login } from '@/redux/actions/auth.js';
import { getDexConfig } from '@/utils/get-dex-config';
import { getEnvAndDex } from '@/utils/get-env-and-dex';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

const AuthRedirect = () => {

	const query = useQuery();
	const authCode = query.get("code");
	const redirectURL = encodeURI(window.location.origin + `/auth/redirect`);
	const { goTo, navigate } = useNavigate();
	const dispatch = useDispatch()

	useEffect(() => {
		const body = {
			code: authCode,
			redirectUrl: redirectURL
		}
		loginHandler(navigate, body)
	}, [])

	async function loginHandler(navigate, body) {
		try {
			await dispatch(login(navigate, body, "authLogin"))
		}
		catch (e) {
			localStorage.clear();
			goTo('/login', {state: { message: e.message }} );
		}
	}

	/*=================================================
		MultiDex
	/================================================*/
	const { dex } = getEnvAndDex();
	const { dexName } = getDexConfig(dex);

	return (
		<div className='layout-login'>
			<DexLeftComponent />
            <div className="layout-login__right">
				<div className="login-box">
                <div className='login-box__title'>Welcome to {dexName} Admin Portal</div>
					<div className="authRedirect-box__title">Hold on!</div>
                    <div className='authRedirect-box__title-display'>
                        <IconInformation className='authRedirect-box__title-icon' />
                        <div className="authRedirect-box__desc">
                            Your organisation has enabled single sign-on authentication. <br />
                            You will be redirected to your organisation's sign-in process.
                        </div>
                    </div>
					<div className="forgetPassword-box__form">
						<div className="forgetPassword-box__form__action">
							<Button text="···" className="authRedirect-box__form__action__top" type="submit" maxWidth="168" full round loading={true} />
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default AuthRedirect
